export default "__VITE_ASSET__B3S5m7O1__"